import React, { useContext } from 'react';
import { BasePage, Helmet, StaticContext } from '@sm/webassets';
import { t, defineMessages } from '@sm/intl';
import { LANGUAGES_BY_CODE } from '@sm/locale';

import theme from '../../styles/SurveyMonkey.theme';

import RebrandEpForm from './RebrandEpForm';
import RebrandEpFormIntl from './RebrandEpFormIntl';
import RebrandExistingUser from './RebrandExistingUser';

const COPY = defineMessages({
  DEFAULT_THANKS_MESSAGE: {
    id: 'SurveyThanks.thanksMessage',
    defaultMessage: 'Thank you for taking this survey.',
  },
  META_KEYWORDS: {
    id: 'SurveyThanks.metaKeywords',
    defaultMessage:
      'questionnaire, questionnaires, questionaire, questionaires, free online survey, free online surveys',
  },
  THANKS_PAGE_TITLE: {
    id: 'SurveyThanks.title',
    defaultMessage: 'Thank you! Create Your Own Online Survey Now! | SurveyMonkey',
  },
});

const SurveyThanks = () => {
  const {
    pageOptions: { canonical, isNonBranded = false, languageId },
    userInfo: { isExistingUser },
  } = useContext(StaticContext);

  const showFooter = !isNonBranded;
  const isInternational = parseInt(languageId, 10) !== LANGUAGES_BY_CODE.en.id;

  return (
    <BasePage includeHeader={false} includeFooter={showFooter} pageId="Survey Thanks" legacyWeb="anonweb" theme={theme}>
      <Helmet>
        <base target="_top" href="/" />
        <meta name="keywords" content={t(COPY.META_KEYWORDS)} />
        <meta name="description" content={t(COPY.DEFAULT_THANKS_MESSAGE)} />
        <link rel="canonical" href={canonical} />
        <title>{t(COPY.THANKS_PAGE_TITLE)}</title>
      </Helmet>
      <Choose>
        <When condition={isExistingUser}>
          <RebrandExistingUser />
        </When>
        <When condition={isInternational}>
          <RebrandEpFormIntl />
        </When>
        <Otherwise>
          <RebrandEpForm />
        </Otherwise>
      </Choose>
    </BasePage>
  );
};

export default SurveyThanks;
